import { SEO_PAGE_MAP, SEO_NOT_FOUND, SEO_POPOUT } from "./seoPages";

const configuredUrl = process.env.REACT_APP_SITE_URL;
if (!configuredUrl) throw new Error("REACT_APP_SITE_URL must identify the public canonical website.");
const configuredSite = new URL(configuredUrl);
if (configuredSite.protocol !== "https:" || configuredSite.pathname !== "/" || configuredSite.search || configuredSite.hash || configuredSite.username || configuredSite.password) throw new Error("REACT_APP_SITE_URL must be an HTTPS origin with no path, query or credentials.");
export const SITE_ORIGIN = configuredSite.origin;
export const SITE_NAME = "Theotokos Mater Dei";
export const normalizeSeoPath = (pathname) => pathname.length > 1 ? pathname.replace(/\/+$/, "").toLowerCase() : "/";
export const seoPageFor = (pathname) => {
  const path = normalizeSeoPath(pathname);
  return path === "/rosary/popout" ? SEO_POPOUT : SEO_PAGE_MAP[path] || { ...SEO_NOT_FOUND, path };
};
export const seoMetadataFor = (page) => {
  const url = `${SITE_ORIGIN}${page.canonicalPath || page.path}`;
  const image = new URL(page.image || "/emblem-512.png", SITE_ORIGIN).href;
  const crumbs = [{ "@type": "ListItem", position: 1, name: SITE_NAME, item: `${SITE_ORIGIN}/` }];
  const segments = page.path.split("/").filter(Boolean);
  for (let depth = 1; depth < segments.length; depth += 1) {
    const ancestorPath = `/${segments.slice(0, depth).join("/")}`;
    const ancestor = SEO_PAGE_MAP[ancestorPath];
    if (ancestor) crumbs.push({ "@type": "ListItem", position: crumbs.length + 1, name: ancestor.heading, item: `${SITE_ORIGIN}${ancestorPath}` });
  }
  if (page.path !== "/") crumbs.push({ "@type": "ListItem", position: crumbs.length + 1, name: page.heading, item: url });
  const graph = [
    { "@type": "WebSite", "@id": `${SITE_ORIGIN}/#website`, name: SITE_NAME, alternateName: "Theotokos · Mater Dei", url: `${SITE_ORIGIN}/`, inLanguage: "en" },
    { "@type": page.type === "article" ? "Article" : "WebPage", "@id": `${url}#page`, url, name: page.title, headline: page.heading, description: page.description, image,
      isPartOf: { "@id": `${SITE_ORIGIN}/#website` }, inLanguage: "en", ...(page.type === "article" ? { mainEntityOfPage: url } : {}) },
    { "@type": "BreadcrumbList", "@id": `${url}#breadcrumbs`, itemListElement: crumbs },
  ];
  // A named website is not evidence of a separate organization or universal article author.
  return { ...page, url, image, imageAlt: page.imageAlt || "Emblem of Theotokos Mater Dei", robots: page.noindex ? "noindex, follow" : "index, follow, max-image-preview:large", jsonLd: { "@context": "https://schema.org", "@graph": graph } };
};